module.exports = __webpack_public_path__ + "img/totalAsset.b03a0f3f.png";